<template>
  <div class="ScrollCover">
    <div class="enterCoverParent">
      <div :style="{ backgroundImage: 'url(' + coverBg + ')' }" class="enterCoverChild">

      </div>
    </div>
    <div class="coverTitles coverBlock">
      <div class="coverContainer">
        <div class="titleContent">
          <h1 class="coverTitle">
            <h6 class="subtitle">{{ coverSubtitle }}</h6>
            <div v-html="coverTitle" v-if="coverTitle"></div>
          </h1>
          <div class="arrow-wrapper">
              <scroll-down-arrow
              icon-color="#7b7a7a"
              v-scroll-to="{
                el: '#nextPage',
                duration: 1500
              }"/>
            </div>
        </div>
      </div>
    </div>
    <div class="coverVideo coverBlock">
      <div class="videoWrapper">
        <video
        data-object-fit="cover"
        class="background-video"
        width="100%"
        :src="coverVideo"
        :poster="coverVideoPoster"
        preload="metadata"
        autobuffer
        muted
        playsinline />
      </div>
    </div>
    <div class="coverTransition">

    </div>
    <div class="coverResume coverBlock">
      <div class="resumeContent">
        <div class="container">
          <h4 class="profileName">{{ introName }}</h4>
          <p>
            {{ introAge }}<br>
            <span v-html="introResume"></span>
          </p>
        </div>
      </div>
    </div>
    <div class="coverIntro">
    </div>
  </div>
</template>

<script>
import { TimelineLite } from 'gsap'
import ScrollDownArrow from '../../general_components/ScrollDownArrow.vue'

export default {
  name: 'ScrollCover',
  data () {
    return {
      isPlayed: false,
      totalScene: null,
      backgroundFadeOut: null,
      titleFadeOut: null,
      fixVideo: null,
      appearVideo: null,
      blurVideo: null
    }
  },
  props: {
    coverBg: String,
    coverVideo: String,
    coverVideoPoster: String,
    coverTitle: String,
    coverSubtitle: String,
    introName: String,
    introAge: String,
    introResume: String
  },
  mounted () {
    let vm = this
    let vid = document.querySelector('.background-video')
    let controller = new this.$sm.Controller();

    this.totalScene = new this.$sm.Scene({triggerElement: ".enterCoverParent", duration: '300%', triggerHook: 'onLeave'})
								.setPin(".enterCoverParent", {pushFollowers: false})
                .addTo(controller);

    let backgroundFadeOutAni = TweenMax.to(".enterCoverParent", 3, {scale: 1.8,  opacity: 0, yoyo: true});
    let titleFadeOutAni = TweenMax.to(".coverTitles", 3, {opacity: 0, yoyo: true});
    // let videoFadeIn = TweenMax.to(vid, .3, {opacity: 1, yoyo: true})

    this.backgroundFadeOut = new this.$sm.Scene({triggerElement: ".ScrollCover", duration: "120%", offset: "-20%", triggerHook: 'onLeave'})
          .setTween(backgroundFadeOutAni)
          .addTo(controller);

    this.titleFadeOut = new this.$sm.Scene({triggerElement: ".coverTitles", duration: "30%", offset: "300%", triggerHook: 'onLeave'})
          .setTween(titleFadeOutAni)
          .addTo(controller);

    this.fixVideo = new this.$sm.Scene({triggerElement: ".coverVideo", duration: '250%', triggerHook: 'onLeave'})
								.setPin(".coverVideo", {pushFollowers: false})
                .addTo(controller);     

    this.appearVideo = new this.$sm.Scene({triggerElement: ".coverVideo", duration: "0%", triggerHook: 'onLeave'})
          .setClassToggle(".coverVideo", "visible")
          .on("enter", function (event) {

            vid.currentTime = 0
            let vidplay = vid.play()
            if (vidplay !== undefined) {
                vidplay.then(_ => {
                  vm.isPlayed = true
                })
                .catch(error => {

                });
            }
          })
          .on("leave", function (event) {
            vid.currentTime = 0
          })
          .addTo(controller);

    this.blurVideo = new this.$sm.Scene({triggerElement: ".coverResume", triggerHook: 'onEnter', duration: "300%"})
								.setClassToggle(".coverVideo", "blur") // add class to reveal
                .addTo(controller);

  },
  components: {
    ScrollDownArrow
  },
  destroyed () {
    this.totalScene.remove();
    this.backgroundFadeOut.remove();
    this.titleFadeOut.remove();
    this.fixVideo.remove();
    this.appearVideo.remove();
    this.blurVideo.remove();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ScrollCover {
  width: 100%;
  position: relative;
  overflow: hidden;
  .enterCoverParent {

    width: 100%;
    height: 100vh;
    position: absolute;
    transform-origin: top center;
    .enterCoverChild {
      z-index: 1;
      width: 100%;
      height: 100%;
      background-color: white;
      background-position: center;
      background-size: cover;
      transition: all .5s;
      animation: backgroundEntry .5s forwards .1s 1;
      will-change: scale, opacity;
      opacity: 0;
      transition: all 1s;
    }
    @keyframes backgroundEntry {
        from {
          transform: scale(1);
        }
        to {
          transform: scale(1.1);
          opacity: 1;
        }
      }
  }
  .coverBlock {
    width: 100%;
    height: 100vh;
    color: black;
  }
  .coverTitles {
    width: 100%;
    .coverContainer {
      margin: 0 auto;
      width: 92%;
      @media (min-width: 768px) and (max-width: 1279.98px) {
          width: 84%;
      }
      @media (min-width: 1280px) {
          width: 78%;
      }
    }
    .titleContent {
      position: relative;
      height: 100vh;
      display: flex;
      // justify-content: center;
      align-items: flex-end;
      h1 {
        opacity: 0;
        animation: titleEntry .5s ease-in forwards;
        margin-bottom: 110px;
        will-change: translate, opacity;
        font-family:'Microsoft JhengHei';
        font-weight: bold;
        @media (min-width: 768px) and (max-width: 1279.98px) {
          width: 84%;
        }
        @media (min-width: 1280px) {
          margin-bottom: 118px;
        }
      }
      @keyframes titleEntry {
        from {
          transform: translateY(100%);
        }
        to {
          transform: translateY(0%);
          opacity: 1;
        }
      }
    }
    .arrow-wrapper {
      position: fixed;
      bottom: 81px;
      left: 50%;
      transform: translateX(-50%);
      @media (min-width: 768px) and (max-width: 1279.98px) {
        
      }
      @media (min-width: 1280px) {
         bottom: 65px;
      }
    }
  }
  .coverTransition {
    position: relative;
    z-index: 1000;
    height: 50vh;
  }
  .coverVideo {
    width: 100%;
    position: relative;
    z-index: 1;
    opacity: 0;
    &::before {
      content: "";
      opacity: 0;
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(black, 0.8);
      transition: opacity 1s ease-in-out;
      -moz-transition: opacity 1s ease-in-out; /* Firefox 4 */
      -webkit-transition: opacity 1s ease-in-out; /* Safari and Chrome */
      -o-transition: opacity 1s ease-in-out; /* Opera */
      -ms-transition: opacity 1s ease-in-out;
    }
    &.visible {    
      opacity: 1
    }
    &.blur {
      &::before {
        transition: opacity 1s ease-in-out;
        -moz-transition: opacity 1s ease-in-out; /* Firefox 4 */
        -webkit-transition: opacity 1s ease-in-out; /* Safari and Chrome */
        -o-transition: opacity 1s ease-in-out; /* Opera */
        -ms-transition: opacity 1s ease-in-out;
        opacity: 1;
        z-index: 1;
      }
    }
    .videoWrapper {
      height: 100%;
      video {
        object-fit:cover;  /* This is the mainly problematic line*/
        overflow:hidden;
        width:100%;
        height:100%;
      }
      .fixObjectFit {

      }
    }
  }
  .coverResume, .coverIntro {
    height: 50vh;
    position: relative;
    z-index: 1000;
    .resumeContent {
      width: inherit;
      color: #fff;
      position: absolute;
      bottom: 129px;
      .profileName {
        margin-bottom: 6px;
        color: white;
      }
    }
  }
}
</style>
